import { render, staticRenderFns } from "./QSCInspectionList.vue?vue&type=template&id=1318280b&scoped=true&"
import script from "./QSCInspectionList.vue?vue&type=script&lang=js&"
export * from "./QSCInspectionList.vue?vue&type=script&lang=js&"
import style0 from "./QSCInspectionList.vue?vue&type=style&index=0&id=1318280b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318280b",
  null
  
)

export default component.exports